import { isMobile } from 'react-device-detect';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  title: {
    paddingBottom: theme.spacing(0.8),
  },

  textBox: {
    width: isMobile ? '100%' : '20%',
  },
  images: {
    '& img': {
      width: 155,
      paddingRight: theme.spacing(4),
      paddingTop: theme.spacing(1),
    },
  },
  button: {
    borderRadius: theme.typography.button.borderRadius,
  },
  legalLinks: {
    display: 'flex',
    fontSize: 12,
    flexDirection: 'column',
    alignItems: isMobile ? 'start' : 'center',
    margin: theme.spacing(isMobile ? 1 : 4, 0),
    '& li': {
      padding: theme.spacing(1.5, 0, 1),
      fontSize: 12,
      '& a': {
        color: theme.palette.grey[50],
        fontWeight: 'normal',
        textDecoration: 'inherit',
      },
    },
  },
}));

export default useStyles;
